import type { FC, HTMLAttributes } from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

import ImageButton, {
    type ImageButtonProps,
} from '@/components/atoms/ImageButton';

const iconsListVariant = cva('flex flex-wrap justify-center gap-4', {
    variants: {
        variant: {
            vertical: 'lg:flex-col',
            horizontalLeft: 'md:flex-row md:justify-start',
            horizontal: 'md:flex-row',
        },
    },
    defaultVariants: {
        variant: 'vertical',
    },
});

export interface IconsLinksListProps
    extends HTMLAttributes<HTMLUListElement>,
        VariantProps<typeof iconsListVariant> {
    iconsData: ImageButtonProps[];
}

const IconsLinksList: FC<IconsLinksListProps> = ({
    iconsData,
    variant,
    className,
}) => (
    <ul className={cn(iconsListVariant({ variant }), className)}>
        {iconsData.map((elem, i) => (
            <li key={'icons-list-item-' + i}>
                <ImageButton {...elem} />
            </li>
        ))}
    </ul>
);

export default IconsLinksList;
